import { css } from '@emotion/css';

export const LEGACY_ADMIN_SIDEBAR_WIDTH = 26;

export const legacyAdminSidebarStyles = css`
  width: ${LEGACY_ADMIN_SIDEBAR_WIDTH}rem;
`;
